import { render, staticRenderFns } from "./VgtPaginationPageInfo.vue?vue&type=template&id=2e4b28ba&scoped=true"
import script from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"
export * from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b28ba",
  null
  
)

export default component.exports